import { BasicTooltip } from "@/components/ui/Tooltip";
import { motion } from "framer-motion";
import { PlusIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { usePlayground } from "../../playground-store";

const AddTestCaseButton = ({ onAdd }: { onAdd: (setId: string) => void }) => {
  const playground = usePlayground();

  return (
    <motion.div
      key="add-button"
      layout
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      transition={{
        duration: 0.2,
        ease: "easeInOut",
      }}
      className="sticky right-0 z-10 ml-2 flex items-center"
    >
      <BasicTooltip content="Add new input variable set">
        <Button
          variant={"default"}
          size={"sm"}
          className="pointer-events-auto h-16 w-16 rounded-full border shadow-sm transition-all duration-200 hover:border-gray-200 hover:shadow-md"
          onClick={() => {
            const newSetId = playground.addEmptyInputVariableSet();
            onAdd(newSetId);
          }}
        >
          <PlusIcon className="h-5 w-5" />
        </Button>
      </BasicTooltip>
    </motion.div>
  );
};

export default AddTestCaseButton;
